<mat-card>
  <mat-card-content>
    <div class="flex flex-col w-11/12">
      <div class="flex flex-col" style="overflow-x:auto">
        <div class="flex flex-row">

          <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #TableSort="matSort"
            class="min-w-full">

            <ng-container matColumnDef="businessName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Business Name</th>
              <td mat-cell *matCellDef="let complaint">
                <a (click)="gotoBusiness(complaint.businessId)">{{complaint.businessName}}</a>
              </td>
            </ng-container>
            <ng-container matColumnDef="businessAddress">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
              <td mat-cell *matCellDef="let complaint">{{complaint.businessAddress}}</td>
            </ng-container>
            <ng-container matColumnDef="businessCity">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>City</th>
              <td mat-cell *matCellDef="let complaint">{{complaint.businessCity}}</td>
            </ng-container>
            <ng-container matColumnDef="businessZip">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Zip Code</th>
              <td mat-cell *matCellDef="let complaint">{{complaint.businessZip}}</td>
            </ng-container>
            <ng-container matColumnDef="visitDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Visit Date</th>
              <td mat-cell *matCellDef="let complaint">{{complaint.visitDate}}</td>
            </ng-container>
            <ng-container matColumnDef="enclosedAreaDetermination">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Most Recent Determination</th>
              <td mat-cell *matCellDef="let complaint">{{complaint.enclosedAreaDetermination}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="expansion-element-row"></tr>

          </table>
        </div>
        <mat-paginator [pageSizeOptions]="[5, 20, 100]" #TablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
      </div>

    </div>
  </mat-card-content>
</mat-card>
